/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import UsersList from "../../Modals/usersList";
import { useNavigate } from "react-router-dom";
import {
  useLazyGetNotificationsQuery,
  useDeleteNotificationMutation,
} from "../../service/notifications";
import ConfirmationDialog from "../../Modals/confirmationModal";
import { Notification } from "../../types/General";
import { showError } from "../../constants/toasts";
import { useLazyGetUsersQuery } from "../../service/users";
import Pagination from "../../components/Panigation";
import { NOTIFICATION_TYPE } from "../../constants/enums";

const NotificationsList = ({ search }: { search: string }) => {
  const navigate = useNavigate();
  const getUserLabel = (row: Notification) => {
    if (row?.isSendToAll) return "All Users";
    return `${row?.broadcastReceivers?.length} Users`;
  };
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [fetchNotifications] = useLazyGetNotificationsQuery();
  const [deleteNotification] = useDeleteNotificationMutation();
  const [getUserList] = useLazyGetUsersQuery();
  const [openUserModal, setOpenUserModal] = React.useState(false);
  const [selectedUserIds, setSelectedUserIds] = React.useState<string[]>([]);
  const [notificationsData, setNotificationsData] = React.useState<
    Notification[]
  >([]);
  const [selectedUser, setSelectedUser] = useState<Notification | null>(null);
  const [usersList, setUsersList] = React.useState<
    { id: string; label: string; avatar: string }[]
  >([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);

  const getNotificationsData = async () => {
    try {
      const response = await fetchNotifications({
        page,
        limit,
        search,
      });
      if (response?.data) {
        const data = response?.data?.data?.list;
        setNotificationsData(data || []);
        setTotalCount(response?.data?.data?.totalCount || 0);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCloseDeleteModal = () => {
    setDeleteModalOpen(false);
  };

  const handleDeleteNotification = async () => {
    if (!selectedUser?._id) {
      console.error("No notification selected for deletion");
      return;
    }
    try {
      await deleteNotification({ id: selectedUser?._id });
      handleCloseDeleteModal();
      getNotificationsData();
    } catch (error) {
      console.log(error);
    }
  };

  const getUsers = async (p?: number) => {
    try {
      const response = await getUserList({
        page: p || page,
        limit,
      }).unwrap();
      if (response.code === 200) {
        const data = response.data.list;
        const users = data.map((user: any) => ({
          label: `${user?.firstName ? user?.firstName : ""} ${
            user?.lastName ? user?.lastName : ""
          }`,
          id: user?._id,
          avatar: user?.image,
        }));
        setUsersList(users);
      }
    } catch (error: any) {
      showError(error.data.message || "");
    }
  };

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
    getUsers(newPage);
  };
  useEffect(() => {
    getUsers();
    getNotificationsData();
  }, [page, search]);

  const totalPages = Math.ceil(totalCount / limit);

  return (
    <>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Title</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Audience</TableCell>
              {/* <TableCell>Schedule</TableCell> */}
              <TableCell>Created Date</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {notificationsData?.map((row) => (
              <TableRow hover key={row._id}>
                <TableCell>{row.title}</TableCell>
                <TableCell>
                  {NOTIFICATION_TYPE[
                    row.type as keyof typeof NOTIFICATION_TYPE
                  ] || row.type}
                </TableCell>
                <TableCell
                  className="click_action"
                  onClick={() => {
                    if (row.isSendToAll) {
                      navigate(`/manage-users`);
                    } else {
                      if (row?.broadcastReceivers?.length > 0) {
                        setSelectedUserIds(row.broadcastReceivers);
                        setOpenUserModal(true);
                      }
                    }
                  }}
                >
                  {row?.broadcastReceivers?.length > 0
                    ? getUserLabel(row)
                    : "0 Users"}
                </TableCell>
                {/* <TableCell>{row.schedule}</TableCell> */}
                <TableCell>
                  {new Date(row.createdAt).toLocaleDateString("en-GB")}
                </TableCell>
                <TableCell>
                  <Box className="table_actions v2">
                    <IconButton
                      onClick={() =>
                        navigate(`/manage-notifications/detail/${row._id}`)
                      }
                    >
                      <img src="/static/images/eye_icon.svg" alt="View" />
                    </IconButton>
                    <IconButton
                      onClick={() => {
                        setSelectedUser(row);
                        setDeleteModalOpen(true);
                      }}
                    >
                      <img src="/static/images/trash2_icon.svg" alt="Delete" />
                    </IconButton>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {totalCount > 0 && (
        <Pagination
          module={notificationsData}
          page={page}
          onPageChange={handlePageChange}
          totalPages={totalPages}
          setPage={setPage}
          totalCount={totalCount}
        />
      )}

      <UsersList
        open={openUserModal}
        onClose={() => setOpenUserModal(false)}
        setOpen={setOpenUserModal}
        userIds={selectedUserIds}
        usersList={usersList}
      />

      <ConfirmationDialog
        open={deleteModalOpen}
        onClose={handleCloseDeleteModal}
        onConfirm={handleDeleteNotification}
        title="Delete Notification"
        confirmText="Delete"
        cancelText="Cancel"
        message={`Are you sure you want to delete notification "${
          selectedUser?.title || ""
        } ${selectedUser?.type || ""}"?`}
        // isLoading={isDeleting}
      />
    </>
  );
};

export default NotificationsList;
